import { render, staticRenderFns } from "./cpt-chart-td-column.vue?vue&type=template&id=9e71d418&scoped=true"
import script from "./cpt-chart-td-column.vue?vue&type=script&lang=js"
export * from "./cpt-chart-td-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e71d418",
  null
  
)

export default component.exports